import React from 'react';
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
} from '@mui/material';
import moment from 'moment';

interface CardData {
  id: number;
  coverPhotoUrl: string;
  title: string;
  category: string;
  type: string;
  author: string;
  purchaseCount: number;
  revenue: number;
  createdAt: any;
  createdBy?: {
    profileUrl?: string;
    firstName?: string;
    lastName?: string;
  };
}

interface ViewAllCardsProps {
  data: CardData[];
  onEditContent?: (id: number) => void;
  onCreateContent?: (id: number) => void;
  titleColor?: string;
  titleFontWeight?: number;
  titleFontSize?: string;
  cardBorderRadius?: string;
  cardBoxShadow?: string;
  buttonBackgroundColor?: string;
  buttonTextColor?: string;
  buttonBorderRadius?: string;
  buttonWidth?: string;
  buttonHeight?: string;
  buttonFontSize?: string;
  buttonFontWeight?: number;
  iconPaths?: {
    category: string;
    author: string;
    course: string;
  };
}

const ViewAllCardsCommon: React.FC<ViewAllCardsProps> = ({
  data,
  onEditContent,
  onCreateContent,
  titleColor = '#233F91',
  titleFontWeight = 700,
  titleFontSize = '18px',
  cardBorderRadius = '15px',
  cardBoxShadow = '3',
  buttonBackgroundColor = '#233F91',
  buttonTextColor = '#fff',
  buttonBorderRadius = '15px',
  buttonWidth = '145px',
  buttonHeight = '48px',
  buttonFontSize = '18px',
  buttonFontWeight = 700,
  iconPaths = {
    category: 'assets/icons/affcategory.png',
    author: 'assets/icons/affprofile.png',
    course: 'assets/icons/affcourse.png',
  },
}) => {
  return (
    <Grid display='flex' gap={5} flexDirection='column' pb={5} px={{ xs: "2px", md: 0 }}>
      {data.map((item: any) => (
        <Card key={item.id} sx={styleSheet.cardConatiner}>
          <CardMedia
            component='img'
            sx={styleSheet.img}
            image={item.coverPhotoUrl}
            onClick={() => onCreateContent && onCreateContent(item.id)}
            alt={item.title}
          />
          <Box sx={styleSheet.cardCOntentContainer}>
            <CardContent sx={styleSheet.cardContent}>
              <Typography
                component='div'
                variant='h6'
                sx={{
                  fontWeight: titleFontWeight,
                  fontSize: titleFontSize,
                  color: titleColor,
                  width: { xs: '293px', md: '337px' },
                }}>
                {item.title}
              </Typography>
              <Box display='flex' alignItems='center' gap={1}>
                <img src={iconPaths.category} alt='Category Icon' />
                <Typography
                  variant='subtitle1'
                  color='text.secondary'
                  component='div'
                  sx={{ fontWeight: 400, fontSize: '17px' }}>
                  {/* {item.category} */}
                  {Array.isArray(item.category)
                    ? item.category.join(', ')
                    : item.category.replace(/\//g, ' / ')}
                </Typography>
              </Box>
              <Box display='flex' alignItems='center' gap={1}>
                {/* Display the user's profile picture */}

                <img
                  src={item?.createdBy?.profileUrl || ''}
                  alt={'User Avatar'}
                  style={{
                    width: '27px',
                    height: '27px',
                    borderRadius: '50%',
                  }}
                />

                <Typography
                  variant='subtitle1'
                  color='text.secondary'
                  component='div'
                  sx={{ fontWeight: 400, fontSize: '17px' }}>
                  {item?.createdBy?.firstName} {item?.createdBy?.lastName}
                </Typography>
              </Box>
              <Box display='flex' alignItems='center' gap={1}>
                <img src={iconPaths.course} alt='Course Icon' />
                <Typography
                  variant='body2'
                  color='text.secondary'
                  component='div'
                  sx={{ fontWeight: 400, fontSize: '17px' }}>
                  {item.type}
                </Typography>
              </Box>
            </CardContent>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'start',
                flexDirection: 'column',
                // width: "300px",
                gap: 2,
                mt: 1,
                ml: { xs: 2, md: 0 },
              }}>
              <Box display='flex' alignItems='center' gap={1}>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading}>
                  Total Purchases:
                </Typography>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading2}>
                  {item?.purchaseCount}

                </Typography>
              </Box>
              <Box display='flex' alignItems='center' gap={'22px'}>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading}>
                  Total Revenue:
                </Typography>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading2}>
                  {item.revenue.toLocaleString(undefined, {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </Typography>
              </Box>
              <Box display='flex' alignItems='center' gap={'22px'}>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading}>
                  Publication Date:
                </Typography>
                <Typography
                  variant='body2'
                  color='text.primary'
                  sx={styleSheet.textHeading2}>
                  {new Date(item?.createdAt.seconds * 1000).toLocaleString()}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Button
              variant='contained'
              sx={{
                backgroundColor: buttonBackgroundColor,
                color: buttonTextColor,
                borderRadius: buttonBorderRadius,
                width: buttonWidth,
                height: buttonHeight,
                fontSize: buttonFontSize,
                fontWeight: buttonFontWeight,
                mr: { xs: 0, md: 3 },
                mt: { xs: 5, md: 0 },
                mb: { xs: '18px', md: 0 },
              }}
              onClick={() => onEditContent && onEditContent(item?.id)}>
              Edit Content
            </Button>
          </Box>
        </Card>
      ))}
    </Grid>
  );
};

export default ViewAllCardsCommon;

const styleSheet = {
  cardConatiner: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    borderRadius: '15px',
    boxShadow: '3',
    padding: 1,
    // width: { xs: '293px', md: '100%' },
    width: { xs: '100%', md: '100%' },
    mx: 'auto',
  },
  img: {
    width: 192,
    height: 192,
    borderRadius: '10px',
    objectFit: 'cover',
    cursor: 'pointer',
  },
  cardCOntentContainer: {
    display: 'flex',
    gap: { xs: 2, md: 0 },
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    flexGrow: 1,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  textHeading: {
    fontWeight: 700,
    fontSize: '18px',
    color: '#233F91',
  },
  textHeading2: {
    fontWeight: 400,
    fontSize: { xs: '14px', md: '18px' },
    color: '#595959',
  },
};
